import { useState } from 'react';
import {
  ClipboardList, Plus, Calendar, Users,
  Clock, CheckCircle, AlertCircle,
  MoreVertical, Filter
} from 'lucide-react';

export default function ProjectsPage() {
  const projects = [
    { id: 1, name: 'Projet A', progress: 75, status: 'en_cours', deadline: '25/02/2026', team: 4 },
    { id: 2, name: 'Projet B', progress: 30, status: 'en_cours', deadline: '10/03/2026', team: 3 },
    { id: 3, name: 'Projet C', progress: 100, status: 'termine', deadline: '15/02/2026', team: 5 },
    { id: 4, name: 'Projet D', progress: 0, status: 'planifie', deadline: '01/04/2026', team: 2 }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Projets
        </h1>
        <button className="px-4 py-2 bg-cyan-600 rounded-lg text-white flex items-center gap-2">
          <Plus size={18} />
          Nouveau projet
        </button>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-gray-900 p-4 rounded-xl border border-gray-800">
          <p className="text-gray-400 text-sm">Total projets</p>
          <p className="text-2xl font-bold text-white">12</p>
        </div>
        <div className="bg-gray-900 p-4 rounded-xl border border-gray-800">
          <p className="text-gray-400 text-sm">En cours</p>
          <p className="text-2xl font-bold text-yellow-400">5</p>
        </div>
        <div className="bg-gray-900 p-4 rounded-xl border border-gray-800">
          <p className="text-gray-400 text-sm">Terminés</p>
          <p className="text-2xl font-bold text-green-400">4</p>
        </div>
        <div className="bg-gray-900 p-4 rounded-xl border border-gray-800">
          <p className="text-gray-400 text-sm">Retard</p>
          <p className="text-2xl font-bold text-red-400">3</p>
        </div>
      </div>

      {/* Liste des projets */}
      <div className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden">
        <div className="grid grid-cols-12 gap-4 p-4 bg-gray-800/50 text-gray-400 text-sm font-medium">
          <div className="col-span-4">Nom du projet</div>
          <div className="col-span-2">Statut</div>
          <div className="col-span-2">Échéance</div>
          <div className="col-span-2">Équipe</div>
          <div className="col-span-2">Progression</div>
        </div>
        <div className="divide-y divide-gray-800">
          {projects.map(project => (
            <div key={project.id} className="grid grid-cols-12 gap-4 p-4 hover:bg-gray-800/30 transition">
              <div className="col-span-4 text-white font-medium">{project.name}</div>
              <div className="col-span-2">
                <span className={`px-2 py-1 rounded-full text-xs ${
                  project.status === 'en_cours' ? 'bg-yellow-500/20 text-yellow-400' :
                  project.status === 'termine' ? 'bg-green-500/20 text-green-400' :
                  'bg-blue-500/20 text-blue-400'
                }`}>
                  {project.status}
                </span>
              </div>
              <div className="col-span-2 text-gray-300">{project.deadline}</div>
              <div className="col-span-2 text-gray-300 flex items-center gap-1">
                <Users size={14} /> {project.team}
              </div>
              <div className="col-span-2">
                <div className="flex items-center gap-2">
                  <div className="flex-1 h-2 bg-gray-800 rounded-full overflow-hidden">
                    <div 
                      className="h-full bg-cyan-500 rounded-full"
                      style={{ width: `${project.progress}%` }}
                    />
                  </div>
                  <span className="text-xs text-gray-400">{project.progress}%</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}